import { useEffect, useRef, useState } from "react";
import useInbox from "hooks/useInbox.ts";
import useOnClickOutside from "../hooks/useOnClickOutside.js";
import { usePicker } from "contexts/pickerContext/pickerContext.ts";
import { useAppSelector } from "store/hooks.ts";
import {
  selectSearchParams,
  selectTParam,
} from "store/selectors/inboxSelectors.ts";

export const useSearchBar = ({ submitCallback } = {}) => {
  const { setSelectedMail, setSearchParams } = useInbox();
  const { setSearchTerm } = usePicker();
  const searchParams = useAppSelector(selectSearchParams);
  const pageType = useAppSelector(selectTParam);

  const [searchValue, setSearchValue] = useState(searchParams?.q);

  const [searchIn, setSearchIn] = useState(pageType);

  const [showSearchInList, setShowSearchInList] = useState(false);

  useEffect(() => {
    setSearchValue(searchParams?.q);
  }, [searchParams?.q]);

  useEffect(() => {
    setSearchIn(pageType);
  }, [pageType]);

  const handleChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  function handleSubmit(e, optional) {
    setSelectedMail(null);

    e.preventDefault();
    if (pageType === "picker" && optional !== "clear") {
      setSearchParams({
        q: optional === "clear" ? "" : searchValue,
      });
      setSearchTerm(searchValue);
    } else {
      setSearchParams({
        q: optional === "clear" ? "" : searchValue,
      });
      if (submitCallback) {
        submitCallback();
      }
    }
  }

  const ref = useRef();
  useOnClickOutside(ref, () => setShowSearchInList(false));

  return {
    handleSubmit,
    handleChange,
    showSearchInList,
    setShowSearchInList,
    searchIn,
    setSearchIn,
    searchValue,
    setSearchValue,
    ref,
  };
};
